import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden-page',
  imports: [],
  templateUrl: './forbidden-page.component.html',
  styleUrl: './forbidden-page.component.scss'
})
export class ForbiddenPageComponent {

}
